<template>
    <div :id="id" class="modal fade" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Confirm Delete</h5>
                </div>
                <div class="modal-body">
                    <div v-if="warning" class="row mb-3">
                        <div class="col-auto h5 font-weight-bold mr-0 pr-0">
                            <i class="fas fa-exclamation-triangle text-warning"></i>WARNING:
                        </div>
                        <div class="col warning-text">
                            {{ warning }}
                        </div>
                    </div>
                    <p>Are you sure you want to delete this {{ name }}?</p>
                </div>
                <div class="modal-footer text-center">
                    <button type="button" class="btn btn-danger" @click="onConfirm">Delete</button>
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                </div>
            </div>
        </div>
    </div>    
</template>

<script>
export default {
    props: {
        name: String,
        warning: String
    },
    data() {
        return {
            id: null,
            event: null,
            value: null
        }
    },
    methods: {
        show: function (value) {
            this.value = value;
            $('#' + this.id).modal('show');
        },
        onConfirm: function () {
            this.$emit('confirm', this.value);
            $('#' + this.id).modal('hide');
        }
    },
    created() {

        // format the object name so we can use it in the element id and event 
        const token = this.name.trim().toLowerCase().replace(' ', '-');

        this.id = 'delete-' + token + '-confirmation';
        this.event = 'show-delete-' + token + '-confirmation';

        eventHub.$on(this.event, this.show);
    },
    beforeDestroy() {
        eventHub.$off(this.event);
    },     
}
</script>

<style scoped>
    .fa-exclamation-triangle.text-warning {
        background:linear-gradient(#000,#000) center bottom/20% 84% no-repeat;
    }

    .warning-text {
        font-weight: bold;
        position: relative;        
        top: 5px;
        line-height: 1.25em;
    }
</style>